import { CALL_API } from '@/middleware/api';
import { TWO_FACTOR_AUTH } from '@/config/api';
import {
  RESEND_TWO_FACTOR_AUTH_CODE,
  RECEIVE_TWO_FACTOR_AUTH_CODE,
  REQUEST_VALIDATE_TWO_FACTOR_AUTH_CODE,
  SUCCESS_VALIDATE_TWO_FACTOR_AUTH_CODE,
  TWO_FACTOR_AUTH_CODE_VALIDATION_FEEDBACK,
  REQUEST_ENABLE_TWO_FACTOR_AUTH_METHODS,
  RECEIVE_ENABLE_TWO_FACTOR_AUTH_METHODS,
  REQUEST_DISABLE_TWO_FACTOR_AUTH_METHODS,
  RECEIVE_DISABLE_TWO_FACTOR_AUTH_METHODS,
  GENERATE_TWO_FACTOR_AUTH_CODE_REQUEST,
  GENERATE_TWO_FACTOR_AUTH_CODE_SUCCESS,
} from './actionsTypes';

export const resendTwoFactorAuthCode = ({ method }) => ({
  [CALL_API]: {
    authenticated: true,
    endpoint: `${TWO_FACTOR_AUTH}/resend`,
    method: 'POST',
    body: { method },
    actionTypes: {
      request: () => ({ type: RESEND_TWO_FACTOR_AUTH_CODE }),
      success: response => ({ type: RECEIVE_TWO_FACTOR_AUTH_CODE, payload: response.data }),
    },
  },
});

export const generateCode = ({ method, action }) => ({
  [CALL_API]: {
    authenticated: true,
    endpoint: `${TWO_FACTOR_AUTH}/generate`,
    method: 'POST',
    body: { method, action },
    actionTypes: {
      request: () => ({ type: GENERATE_TWO_FACTOR_AUTH_CODE_REQUEST }),
      success: response => ({ type: GENERATE_TWO_FACTOR_AUTH_CODE_SUCCESS, payload: response.data }),
    },
  },
});

export const getEnableTwoFactorAuthMethods = () => ({
  [CALL_API]: {
    authenticated: true,
    endpoint: `${TWO_FACTOR_AUTH}/enable`,
    method: 'PATCH',
    actionTypes: {
      request: () => ({ type: REQUEST_ENABLE_TWO_FACTOR_AUTH_METHODS }),
      success: response => ({ type: RECEIVE_ENABLE_TWO_FACTOR_AUTH_METHODS, payload: response.data }),
    },
  },
});

export const getDisableTwoFactorAuthMethods = () => ({
  [CALL_API]: {
    authenticated: true,
    endpoint: `${TWO_FACTOR_AUTH}/disable`,
    method: 'PATCH',
    actionTypes: {
      request: () => ({ type: REQUEST_DISABLE_TWO_FACTOR_AUTH_METHODS }),
      success: response => ({ type: RECEIVE_DISABLE_TWO_FACTOR_AUTH_METHODS, payload: response.data }),
    },
  },
});

export const setValidationFeedback = ({ hasError }) => ({
  type: TWO_FACTOR_AUTH_CODE_VALIDATION_FEEDBACK,
  payload: { hasError },
});

export const validateTwoFactorAuthCode = ({ code, action }) => ({
  [CALL_API]: {
    authenticated: true,
    endpoint: `${TWO_FACTOR_AUTH}/validate`,
    method: 'POST',
    body: { code, action },
    actionTypes: {
      request: () => ({ type: REQUEST_VALIDATE_TWO_FACTOR_AUTH_CODE }),
      success: response => ({ type: SUCCESS_VALIDATE_TWO_FACTOR_AUTH_CODE, payload: response.data }),
      error: () => setValidationFeedback({ hasError: true }),
    },
  },
});
